export default __webpack_public_path__ + "static/media/search-icon.16cb842f.svg";